import { useBrandKitStore } from '../../creative/store/brand-kit-store'
import { DEFAULT_TIMEZONE, getBrowserTimezone } from '../utils/business-timezone'

/**
 * Resolved IANA timezone for *displaying* already-persisted instants —
 * `brandKit.timezone` when captured, else `DEFAULT_TIMEZONE` ('UTC') so the
 * client buckets posts into the same calendar day the server does. Pair with
 * `useEnsureBrandKitTimezone()` on surfaces that need the real value so the
 * fallback window is one render at most.
 *
 * For interpreting a wall-clock the *user just typed* into a scheduler, use
 * `useScheduleTimezone()` instead — its browser fallback matches the user's
 * actual clock rather than UTC.
 */
export function useBrandTimezone(): string {
  return useBrandKitStore(s => s.brandKit.timezone) ?? DEFAULT_TIMEZONE
}

/**
 * Resolved IANA zone to anchor a user-entered schedule wall-clock to —
 * `brandKit.timezone` when captured, else the BROWSER zone. The browser
 * fallback is deliberate: when the brand hasn't set a zone yet, "9am" should
 * mean 9am where the user is, not 9am UTC. This mirrors what every other
 * scheduling surface does (PostModal, CreatePostButton, calendar reschedule,
 * autopilot) so all writes agree on what instant a picked time maps to.
 */
export function useScheduleTimezone(): string {
  return useBrandKitStore(s => s.brandKit.timezone) ?? getBrowserTimezone()
}
